
import { Component, Prop, Vue } from 'vue-property-decorator';
import { checkPicVerifyCode, getUseCode, getCode, checkPicVerifyUseCode } from '@/api/other';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'sendCode',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: String,
    default: ''
  })mobile!:String;

  @Prop({
    type: Number,
    default: 0
  })sendType!:Number;
  @Prop({
    type: Boolean,
    default: true
  })mobileVisible!:Boolean;

  @Prop({
    type: Boolean,
    default: false
  })sendDisabled!:Boolean;

  private dialogVerifyCodeVisible=false
  private viewData:any={
    mobile: '',
    code: '',
    picCode: '',
    picInputCode: ''
  };
  private timedown=60;
  private sendtext='获取验证码'
  private timer:any=''

  private isDisabled = this.sendDisabled || false
  created() {
    this.viewData.mobile = this.mobile;
    this.timedown = 60;
    this.sendtext = '获取验证码';
    this.timer = '';
  }
  private sendCode() {
    if (!this.viewData.mobile) {
      this.showErrorMsg('请输入手机号');
      return;
    }
    if (this.timedown < 60) {
      return;
    }
    this.sendtext = this.timedown + 's';
    this.timer = setInterval(() => {
      this.timedown--;
      if (this.timedown <= 0) {
        clearInterval(this.timer);
        this.timedown = 60;
        this.sendtext = '重新获取';
        return;
      }
      this.sendtext = this.timedown + 's';
    }, 1000);
    this.getVerifyCode(1);
  }
  private getVerifyCode(type:number) {
    let map:any = {};
    map.send_type = this.sendType;
    map.mobile = this.viewData.mobile;
    switch (this.sendType) {
      case 12:
      case 13:
      case 23:
      case 24:
        getCode(map).then(res => {
          if (res.data && res.data.image_code) {
            this.viewData.picCode = res.data.image_code;
            if (type === 1) {
              this.dialogVerifyCodeVisible = true;
            }
          }
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 21:
      case 22:
      case 25:
      case 26:
        map.account_id = UserModule.getAccountId;
        getUseCode(map).then(res => {
          if (res.data && res.data.image_code) {
            this.viewData.picCode = res.data.image_code;
            if (type === 1) {
              this.dialogVerifyCodeVisible = true;
            }
          }
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
    }
  }
  private checkPicVerify() {
    if (!this.viewData.picInputCode) {
      this.showErrorMsg('请输入图形验证码');
      return;
    }
    let map:any = {};
    map.send_type = this.sendType;
    map.mobile = this.viewData.mobile;
    map.image_code = this.viewData.picInputCode;
    switch (this.sendType) {
      case 12:
      case 13:
      case 23:
      case 24:
        checkPicVerifyCode(map).then(res => {
          this.dialogVerifyCodeVisible = false;
          this.$emit('codeImg', true);
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 21:
      case 22:
      case 25:
      case 26:
        map.account_id = UserModule.getAccountId;
        checkPicVerifyUseCode(map).then(res => {
          this.dialogVerifyCodeVisible = false;
          this.$emit('codeImg', true);
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
    }
  }
  private imgVerifyClick() {
    this.getVerifyCode(0);
  }
  private verifyCodeClose() {
    this.dialogVerifyCodeVisible = false;
  }
  private codeInputChange(val:string) {
    if (this.isDisabled) {
      this.$emit('accountInput', this.viewData.mobile);
    }
    this.$emit('codeInput', val);
  }
  private InputChange(val: any) {
    this.$emit('accountInput', this.viewData.mobile);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
